import React from 'react';
import Header_gamebox from '../Components/Header_gamebox';
import about from '../Assets/about.png'

const About = () => {
  return (
    <>
    <Header_gamebox/>
      <div className='flex flex-col justify-between items-center lg:flex-row' >
      <div>
        <img src={about} alt='...' />
      </div>
      <div>
        <h1 class="lg:text-7xl text-5xl font-bold font-sans text-center " >To Win Big</h1>
        <h1 class="lg:text-7xl text-5xl font-bold text-red-700 text-center" >On Game Box</h1>
      </div>

      </div>
      <div className='bg-black text-white'>
        <h2 class="flex justify-center lg:text-4xl text-2xl font-mono items-center font-bold m-0" >About Game Box
</h2>
<div class="w-[250px] lg:w-[700px] md:w-[300px] mx-auto p-2" >
<p class="text-left lg:text-3xl text-sm m-0">
{/* Join Game Box , the ultimate game for Game  enthusiasts! Test your Game Box knowledge, earn points, and stand a chance to win incredible prizes,
 including a trip to watch the EPL finals, cash prizes, and airtime. With a subscription price of N100 per day and N200 per week, 
enjoy multiple plays for an added fee of N50 per game. 
All MTN Nigeria customers with valid mobile numbers are eligible to participate. Subscribers receive 10 points daily,
 automatically qualifying them for the daily draw. Unleash your passion for Game and embark on an exciting journey with 
Game Box  today! */}
GameBox is your ultimate destination for mobile gaming and entertainment!
 With a subscription fee of ₦150 daily or ₦200 weekly, you gain access to a wide variety of exciting games 
across multiple categories, including action, puzzles, sports, strategy, trivia, arcade, and more. Enjoy endless fun,
 discover new challenges, and play your favorite games anytime, anywhere. The daily plan gives you uninterrupted access
 for 24 hours, while the weekly plan keeps the excitement going for 7 days. GameBox delivers a fun-filled and engaging
 gaming experience for players of all ages.


</p>

</div>
      </div>
    </>
  );
}

export default About;
